export const LOGIN_LOGIN = "login";
export const LOGIN_SIGNUP = "signup";
export const LOGIN_ACTIVATEACCOUNT = "activateaccount";
export const LOGIN_ACTIVATESUCCESS = "activatesuccess";
export const LOGIN_INITIALIZING = "initializing";
export const LOGIN_FORGETPASSWORD = "forgetpassword";
export const LOGIN_RESETPASSWORD = "resetpassword";
export const LOGIN_CHECKSIGNMAIL = "checksignmail";
export const LOGIN_CHECKRESETMAIL = "checkresetmail";
export const LOGIN_RESETSUCCESS = "resetsuccess";
export const LOGIN_WARNING = "warning";
export const LOGIN_PERMISSIONDENIED = "permissiondenied";

export const ROUTE_LOGIN = "/login";
export const ROUTE_DASHBOARD = "/dashBoard";
export const ROUTE_THING = "/thing";
export const ROUTE_THING_CREATEEDIT = "/thing/createEdit";
export const ROUTE_THING_INFOMAIN = "/thing/infomain";
export const ROUTE_THING_EDITBUCKETS = "/thing/editBuckets";
export const ROUTE_PROJECT = "/project";
export const ROUTE_PROJECT_INFORMATION = "/project/information";
export const ROUTE_APPLICATION = "/application";
export const ROUTE_APPLICATION_INFORMATION = "/application/information";
export const ROUTE_APPLICATION_CREATE = "/application/create";
export const ROUTE_APPLICATION_EDIT = "/application/edit";
export const ROUTE_MEMBER = "/member";
export const ROUTE_EVENTLOG = "/eventLog";
export const ROUTE_PROFILE = "/profile";

export const AUTH_SESSION = "Session";
export const AUTH_BEARER = "Bearer";

export const TOKEN_SESSION = "sessionToken";
export const TOKEN_ACCESS = "accessToken";

export const THING_ID = "thingId";
export const APPLICATION_ID = "applicationId";
export const PROJECT_ID = "projectId";

export const USER_ID = "userID";
export const USER_NAME = "userName";
export const USER_EMAIL = "userEmail";
export const USER_ORG = "userOrg";

export const API_LOGIN = "/v4/session";
export const API_TOKEN = "/v4/oauth/token";
export const API_GETME = "/v4/me";
export const API_GET_ORG = "/v4/org";
export const API_GETDASHBOARD = "/v4/dashboard/things";
export const API_THINGS = "/v4/things";
export const API_THINGS_CONFIGS = "/configs";
export const API_THINGS_LABELS = "/labels";
export const API_THINGS_BUCKETS = "/data-buckets";
export const API_THINGS_SHAPES = "/data-shapes";
export const API_MEMBERS = "/v4/members";
export const API_APPLICATION = "/v4/apps";
export const API_PROJECTS = "/v4/projects";
export const API_GETUSERACTIONS = "/v4/activity-log";
export const API_GETFAILEDLOGINS = "/v4/failed-login-attempts";
